export default __webpack_public_path__ + "static/media/GitHub-Mark-Light-64px.c9a5f25d.webp";